module.exports = __webpack_public_path__ + "076fad0c6d601a41681195eb55693294.jpg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/authors/andrew.jpg
// module id = 482
// module chunks = 0